import React from "react";
import { Box, Skeleton } from "@mui/material";
import Grid2 from "@mui/material/Grid2";

const DashboardSkeleton = () => (
  <Box>
    <Skeleton variant="text" width={240} height={40} sx={{ mb: 2 }} />
    <Grid2 container spacing={2} sx={{ mb: 2 }}>
      {[0, 1, 2].map((i) => (
        <Grid2 key={i} size={{ xs: 12, md: 4 }}>
          <Skeleton variant="rounded" height={220} />
        </Grid2>
      ))}
    </Grid2>
    <Skeleton variant="text" width={180} height={32} sx={{ mb: 1 }} />
    <Grid2 container spacing={2}>
      {Array.from({ length: 8 }).map((_, i) => (
        <Grid2 key={i} size={{ xs: 12, sm: 6, md: 3 }}>
          <Skeleton variant="rounded" height={120} />
        </Grid2>
      ))}
    </Grid2>
  </Box>
);

export default DashboardSkeleton;
